import CardMedia from '@mui/material/CardMedia';

import { Typography, Card, CardContent } from '@occc-app/design-system';
import { MarketingContentFragment } from '@occc/graphql';

type MarketingContentPreviewProps = {
  marketingContent: MarketingContentFragment;
};

export const MarketingContentPreview = ({ marketingContent }: MarketingContentPreviewProps) => {
  const { imageUrl, title, shortDescription, longDescription } = marketingContent;

  return (
    <Card>
      <CardMedia
        sx={(theme) => ({
          pb: '40%',
          bgcolor: theme.palette.grey[300],
        })}
        image={imageUrl ?? undefined}
      />
      <CardContent>
        {title && (
          <Typography gutterBottom variant='h6' component='h4'>
            {title}
          </Typography>
        )}
        {shortDescription && <Typography gutterBottom>{shortDescription}</Typography>}
        {longDescription && <Typography>{longDescription}</Typography>}
      </CardContent>
    </Card>
  );
};
